// Build-time feature flags for the admin frontend. Values are read from
// Vite env vars (`VITE_*`), so flipping a flag requires a rebuild. This
// matches the backend's `RECONCILIATION_ENABLED` posture — the two must
// stay in sync at deploy time.
//
// Strict string-equals against 'true' so typos like '1' / 'yes' / 'TRUE'
// don't accidentally enable a gated feature.

export const isReconciliationEnabled = (): boolean =>
  import.meta.env.VITE_RECONCILIATION_ENABLED === 'true';

// #1301: the invoice hold-rule editor writes rules that nothing evaluates.
// `EvaluateHoldRules` (internal/services/email/hold_rules.go) has had zero
// production callers since Temporal was removed (#470), so the settings block
// is hidden unless a deployment explicitly opts into the Phase 4 preview.
export const isEmailHoldRulesEnabled = (): boolean =>
  import.meta.env.VITE_EMAIL_HOLD_RULES_ENABLED === 'true';

// FEATURE_FLAGS is a frozen snapshot captured at module load. Prefer it
// for render-time reads so the flag value doesn't fluctuate if the env
// ever changes mid-session (it shouldn't — Vite inlines these at build
// time — but the frozen object makes the invariant explicit).
//
// Exception: a component whose tests stub the env var per case must call the
// predicate instead, because the snapshot is captured once per module load and
// `vi.stubEnv` cannot reach it. `EmailScheduleSection` calls
// `isEmailHoldRulesEnabled()` for that reason.
export const FEATURE_FLAGS = {
  reconciliation: isReconciliationEnabled(),
  emailHoldRules: isEmailHoldRulesEnabled(),
} as const;
